import React, { type ComponentType } from 'react';
import Placeholder from '@atlassian/jira-placeholder/src/index.tsx';
import { lazy } from '@atlassian/react-loosely-lazy';
import type GenericPermissionErrorPageType from './ui/generic-permission-error-page/GenericPermissionErrorPage.tsx';
import type { JSErrorPageProps } from './ui/js-error-page/JSErrorPage.tsx';
import type WallboardPermissionErrorPageType from './ui/wallboard-permission-error-page/WallboardPermissionErrorPage.tsx';
import type { DashboardKnownErrorsPageProps } from './ui/dashboard-known-errors-page/DashboardKnownErrorsPage.tsx';

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const LazyJSErrorPage = lazy<ComponentType<JSErrorPageProps>>(
	() => import(/* webpackChunkName: "async-js-error-page" */ './ui/js-error-page/JSErrorPage.tsx'),
);

export const JSErrorPageAsync = (props: JSErrorPageProps) => (
	<Placeholder name="async-js-error-page" fallback={null}>
		<LazyJSErrorPage {...props} />
	</Placeholder>
);

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const LazyNotFoundErrorPage = lazy<ComponentType<{}>>(
	() =>
		import(
			/* webpackChunkName: "async-not-found-error-page" */ './ui/not-found-error-page/NotFoundErrorPage.tsx'
		),
);

export const NotFoundErrorPageAsync = () => (
	<Placeholder name="async-not-found-error-page" fallback={null}>
		<LazyNotFoundErrorPage />
	</Placeholder>
);

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const LazyDashboardKnownErrorsPage = lazy<ComponentType<DashboardKnownErrorsPageProps>>(
	() =>
		import(
			/* webpackChunkName: "async-dashboard-known-errors-page" */ './ui/dashboard-known-errors-page/DashboardKnownErrorsPage.tsx'
		),
);

export const DashboardKnownErrorsPageAsync = (props: DashboardKnownErrorsPageProps) => (
	<Placeholder name="async-dashboard-known-errors-page" fallback={null}>
		<LazyDashboardKnownErrorsPage {...props} />
	</Placeholder>
);

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const LazyWallboardPermissionErrorPage = lazy<typeof WallboardPermissionErrorPageType>(
	() =>
		import(
			/* webpackChunkName: "async-wallboard-permission-error-page" */ './ui/wallboard-permission-error-page/WallboardPermissionErrorPage.tsx'
		),
);

export const WallboardPermissionErrorPageAsync = () => (
	<Placeholder name="async-wallboard-permission-error-page" fallback={null}>
		<LazyWallboardPermissionErrorPage />
	</Placeholder>
);

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const LazyGenericPermissionErrorPage = lazy<typeof GenericPermissionErrorPageType>(
	() =>
		import(
			/* webpackChunkName: "async-generic-permission-error-page" */ './ui/generic-permission-error-page/GenericPermissionErrorPage.tsx'
		),
);

export const GenericPermissionErrorPageAsync = () => (
	<Placeholder name="async-generic-permission-error-page" fallback={null}>
		<LazyGenericPermissionErrorPage />
	</Placeholder>
);
